var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeaturedProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "88px",
    height: "84px",
    viewBox: "0 0 88 84",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.-Upgrade-&-Payment-\\uD83D\\uDCB3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Upgrade-2",
    transform: "translate(-144.000000, -110.000000)",
    fillRule: "nonzero",
    stroke: "#CCCCCC",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Upgrade/Feature",
    transform: "translate(113.000000, 81.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Star",
    points: "75 96.5 49.7252342 109.787731 54.5522849 81.6438654 34.1045698 61.7122692 62.3626171 57.6061346 75 32 87.6373829 57.6061346 115.89543 61.7122692 95.4477151 81.6438654 100.274766 109.787731"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedProfile);
export default __webpack_public_path__ + "static/media/featured_profile.e41fb6054f759b968b7fd14aae6991d7.svg";
export { ForwardRef as ReactComponent };